'use strict'

import React from 'react'
import { ChromePicker } from 'react-color'

class ColorPicker extends React.Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            displayColorPicker: false,
            color: this.props.value || '#000',
            onChange: this.props.onChange || function (){},
            className: this.props.className || ''
        }
        this.handleClick = this.handleClick.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({color: nextProps.value || '#000'})
    }

    handleClick() {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    }

    handleClose() {
        this.setState({ displayColorPicker: false })
    }

    handleChange(color) {
        this.setState({ color: color.hex })
        this.state.onChange(color.hex)
    }

    render() {

        const styles = {
            color: {
                width: '50px',
                height: '20px',
                borderRadius: '2px',
                backgroundColor: this.state.color,
            },
            swatch: {
                padding: '5px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
            },
            popover: {
                position: 'absolute',
                zIndex: '2',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            },
        }

        return (
            <div className={this.state.className}>
                <div style={ styles.swatch } onClick={ this.handleClick }>
                    <div style={ styles.color } />
                </div>
                { this.state.displayColorPicker ? <div style={ styles.popover }>
                    <div style={ styles.cover } onClick={ this.handleClose }/>
                    <ChromePicker color={ this.state.color } onChange={ this.handleChange } />
                </div> : null }

            </div>
        )
    }
}

export default ColorPicker


// WEBPACK FOOTER //
// ./src/common/color/picker.component.jsx